import { ToastContainer } from "react-toastify";
import { styled } from "styled-components";

export const StyledToastContainer = styled(ToastContainer)`
  & .Toastify__toast {
    background-color: ${({ theme }) => theme.colors.background.layers[600]};
    border: 1px solid ${({ theme }) => theme.colors.border.weak};
    border-radius: ${({ theme }) => theme.spacing[1]};
    padding: ${({ theme }) => theme.spacing[4]};
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.15);
  }

  & .Toastify__close-button {
    color: ${({ theme }) => theme.colors.text.primary.color};
  }
`;
